import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import type { PlanBillingData, SyncStatus } from '@vy/types';
import React from 'react';
import { ContractPageHeaderMenu } from '../../../contract/contract-page-components/ContractPageHeaderMenu/ContractPageHeaderMenu';

type ContractDotMenuProps = {
  contractId: string;
  planId: string;
  planName: string;
  billingData: PlanBillingData;
  isActive: boolean;
  customerName: string;
  customerId: string;
  isTerminated: boolean;
  syncStatus: SyncStatus;
  contractStartDate: Date;
  contractEndDate?: Date;
  isEditable: boolean;
};

export const ContractDotMenu: React.FC<ContractDotMenuProps> = ({
  contractId,
  planId,
  planName,
  billingData,
  customerName,
  customerId,
  isActive,
  isTerminated,
  syncStatus,
  contractStartDate,
  contractEndDate,
  isEditable,
}) => {
  return (
    <div
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="flex justify-center"
    >
      <ContractPageHeaderMenu
        isContractEditable={isEditable}
        contractId={contractId}
        planId={planId}
        planName={planName}
        billingData={billingData}
        customerName={customerName}
        isActive={isActive}
        isTerminated={isTerminated}
        customerId={customerId}
        contractStartDate={contractStartDate}
        contractEndDate={contractEndDate}
        contractName={planName}
        syncStatus={syncStatus}
      >
        <IconButton disableRipple>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </ContractPageHeaderMenu>
    </div>
  );
};
